/**
 * @generated SignedSource<<13e9ffdd52a847231e46b19c3607c83d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FollowDealerButton_seller$data = {
  readonly favoritesByUser?: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "FollowDealerButton_seller";
};
export type FollowDealerButton_seller$key = {
  readonly " $data"?: FollowDealerButton_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"FollowDealerButton_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowDealerButton_seller",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId"
            }
          ],
          "concreteType": "Favorite",
          "kind": "LinkedField",
          "name": "favoritesByUser",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "91934bcd1aa83cf32517ff94396a20d3";

export default node;
